// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  .chat-page {
    min-height: 100vh;
    background-color: #1a2332;
    padding: 120px 60px 60px 60px;
  }
  
  .chat-container {
    background-color: white;
    border-radius: 12px;
    height: calc(100vh - 180px);
    display: flex;
    flex-direction: column;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  
  .chat-header {
    padding: 15px 30px;
    border-bottom: 1px solid #e0e0e0;
    min-height: 60px;
    display: flex;
    align-items: center;
  }
  
  .chat-header h2 {
    font-size: 20px;
    font-weight: 600;
    color: #333;
  }
  
  .chat-messages {
    flex: 1 1;
    padding: 30px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  
  .empty-state {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    font-size: 18px;
    color: #999;
  }
  
  .message-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 15px;
    margin-left: auto;
    max-width: 80%;
  }
  
  .message-content {
    background-color: #f5f5f5;
    padding: 12px 18px;
    border-radius: 12px;
    font-size: 15px;
    color: #333;
    word-wrap: break-word;
  }
  
  .user-icon {
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    background-color: #e0e0e0;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .chat-input-container {
    border-top: 1px solid #e0e0e0;
    padding: 20px 30px;
  }
  
  .source-selector {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 15px;
    flex-wrap: wrap;
  }
  
  .source-label {
    font-weight: 600;
    color: #333;
    font-size: 14px;
  }
  
  .source-buttons {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }
  
  .source-button {
    padding: 8px 20px;
    border: 2px solid #ddd;
    background-color: white;
    border-radius: 20px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    color: #333;
    transition: all 0.3s ease;
  }
  
  .source-button:hover {
    border-color: #4CAF50;
  }
  
  .source-button.active {
    background-color: #4CAF50;
    border-color: #4CAF50;
    color: white;
  }
  
  .input-row {
    display: flex;
    gap: 15px;
  }
  
  .message-input {
    flex: 1 1;
    padding: 12px 20px;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    font-size: 15px;
    outline: none;
    transition: border-color 0.3s ease;
  }
  
  .message-input:focus {
    border-color: #2196F3;
  }
  
  .message-input::placeholder {
    color: #999;
  }
  
  .send-button {
    padding: 12px 30px;
    background-color: #2196F3;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.3s ease;
    white-space: nowrap;
  }
  
  .send-button:hover {
    background-color: #1976D2;
  }
  
  @media (max-width: 1024px) {
    .chat-page {
      padding: 100px 40px 40px 40px;
    }
    
    .chat-container {
      height: calc(100vh - 140px);
    }
  }
  
  @media (max-width: 768px) {
    .chat-page {
      padding: 80px 20px 20px 20px;
    }
    
    .chat-container {
      height: calc(100vh - 100px);
    }
    
    .chat-header {
      padding: 12px 20px;
      min-height: 50px;
    }
    
    .chat-header h2 {
      font-size: 18px;
    }
    
    .chat-messages {
      padding: 20px;
    }
    
    .message-row {
      max-width: 90%;
    }
    
    .chat-input-container {
      padding: 15px 20px;
    }
    
    .source-selector {
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
    }
    
    .input-row {
      flex-direction: column;
      gap: 10px;
    }
    
    .send-button {
      width: 100%;
    }
  }
  
  @media (max-width: 480px) {
    .chat-page {
      padding: 60px 15px 15px 15px;
    }
    
    .chat-header h2 {
      font-size: 16px;
    }
    
    .chat-messages {
      padding: 15px;
    }
    
    .message-content {
      font-size: 14px;
      padding: 10px 15px;
    }
    
    .user-icon {
      width: 32px;
      height: 32px;
    }
    
    .source-button {
      padding: 6px 16px;
      font-size: 13px;
    }
    
    .message-input {
      padding: 10px 15px;
      font-size: 14px;
    }
    
    .send-button {
      padding: 10px 20px;
      font-size: 14px;
    }
  }

  
  `, "",{"version":3,"sources":["webpack://./src/components/covfile/ChatAi.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,wCAAwC;EAC1C;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;IAChC,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,SAAO;IACP,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;IAC7B,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,SAAO;IACP,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,kCAAkC;EACpC;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,sCAAsC;IACtC,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE;MACE,6BAA6B;IAC/B;;IAEA;MACE,2BAA2B;IAC7B;EACF;;EAEA;IACE;MACE,4BAA4B;IAC9B;;IAEA;MACE,2BAA2B;IAC7B;;IAEA;MACE,kBAAkB;MAClB,gBAAgB;IAClB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,sBAAsB;MACtB,uBAAuB;MACvB,SAAS;IACX;;IAEA;MACE,sBAAsB;MACtB,SAAS;IACX;;IAEA;MACE,WAAW;IACb;EACF;;EAEA;IACE;MACE,4BAA4B;IAC9B;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,eAAe;MACf,kBAAkB;IACpB;;IAEA;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,iBAAiB;MACjB,eAAe;IACjB;;IAEA;MACE,kBAAkB;MAClB,eAAe;IACjB;;IAEA;MACE,kBAAkB;MAClB,eAAe;IACjB;EACF","sourcesContent":["* {\r\n    margin: 0;\r\n    padding: 0;\r\n    box-sizing: border-box;\r\n  }\r\n  \r\n  .chat-page {\r\n    min-height: 100vh;\r\n    background-color: #1a2332;\r\n    padding: 120px 60px 60px 60px;\r\n  }\r\n  \r\n  .chat-container {\r\n    background-color: white;\r\n    border-radius: 12px;\r\n    height: calc(100vh - 180px);\r\n    display: flex;\r\n    flex-direction: column;\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n  }\r\n  \r\n  .chat-header {\r\n    padding: 15px 30px;\r\n    border-bottom: 1px solid #e0e0e0;\r\n    min-height: 60px;\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n  \r\n  .chat-header h2 {\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n    color: #333;\r\n  }\r\n  \r\n  .chat-messages {\r\n    flex: 1;\r\n    padding: 30px;\r\n    overflow-y: auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n  }\r\n  \r\n  .empty-state {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    height: 100%;\r\n    font-size: 18px;\r\n    color: #999;\r\n  }\r\n  \r\n  .message-row {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: flex-start;\r\n    gap: 15px;\r\n    margin-left: auto;\r\n    max-width: 80%;\r\n  }\r\n  \r\n  .message-content {\r\n    background-color: #f5f5f5;\r\n    padding: 12px 18px;\r\n    border-radius: 12px;\r\n    font-size: 15px;\r\n    color: #333;\r\n    word-wrap: break-word;\r\n  }\r\n  \r\n  .user-icon {\r\n    flex-shrink: 0;\r\n    width: 36px;\r\n    height: 36px;\r\n    background-color: #e0e0e0;\r\n    border-radius: 50%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .chat-input-container {\r\n    border-top: 1px solid #e0e0e0;\r\n    padding: 20px 30px;\r\n  }\r\n  \r\n  .source-selector {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 15px;\r\n    margin-bottom: 15px;\r\n    flex-wrap: wrap;\r\n  }\r\n  \r\n  .source-label {\r\n    font-weight: 600;\r\n    color: #333;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .source-buttons {\r\n    display: flex;\r\n    gap: 10px;\r\n    flex-wrap: wrap;\r\n  }\r\n  \r\n  .source-button {\r\n    padding: 8px 20px;\r\n    border: 2px solid #ddd;\r\n    background-color: white;\r\n    border-radius: 20px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    color: #333;\r\n    transition: all 0.3s ease;\r\n  }\r\n  \r\n  .source-button:hover {\r\n    border-color: #4CAF50;\r\n  }\r\n  \r\n  .source-button.active {\r\n    background-color: #4CAF50;\r\n    border-color: #4CAF50;\r\n    color: white;\r\n  }\r\n  \r\n  .input-row {\r\n    display: flex;\r\n    gap: 15px;\r\n  }\r\n  \r\n  .message-input {\r\n    flex: 1;\r\n    padding: 12px 20px;\r\n    border: 2px solid #e0e0e0;\r\n    border-radius: 8px;\r\n    font-size: 15px;\r\n    outline: none;\r\n    transition: border-color 0.3s ease;\r\n  }\r\n  \r\n  .message-input:focus {\r\n    border-color: #2196F3;\r\n  }\r\n  \r\n  .message-input::placeholder {\r\n    color: #999;\r\n  }\r\n  \r\n  .send-button {\r\n    padding: 12px 30px;\r\n    background-color: #2196F3;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 8px;\r\n    font-size: 15px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n    white-space: nowrap;\r\n  }\r\n  \r\n  .send-button:hover {\r\n    background-color: #1976D2;\r\n  }\r\n  \r\n  @media (max-width: 1024px) {\r\n    .chat-page {\r\n      padding: 100px 40px 40px 40px;\r\n    }\r\n    \r\n    .chat-container {\r\n      height: calc(100vh - 140px);\r\n    }\r\n  }\r\n  \r\n  @media (max-width: 768px) {\r\n    .chat-page {\r\n      padding: 80px 20px 20px 20px;\r\n    }\r\n    \r\n    .chat-container {\r\n      height: calc(100vh - 100px);\r\n    }\r\n    \r\n    .chat-header {\r\n      padding: 12px 20px;\r\n      min-height: 50px;\r\n    }\r\n    \r\n    .chat-header h2 {\r\n      font-size: 18px;\r\n    }\r\n    \r\n    .chat-messages {\r\n      padding: 20px;\r\n    }\r\n    \r\n    .message-row {\r\n      max-width: 90%;\r\n    }\r\n    \r\n    .chat-input-container {\r\n      padding: 15px 20px;\r\n    }\r\n    \r\n    .source-selector {\r\n      flex-direction: column;\r\n      align-items: flex-start;\r\n      gap: 10px;\r\n    }\r\n    \r\n    .input-row {\r\n      flex-direction: column;\r\n      gap: 10px;\r\n    }\r\n    \r\n    .send-button {\r\n      width: 100%;\r\n    }\r\n  }\r\n  \r\n  @media (max-width: 480px) {\r\n    .chat-page {\r\n      padding: 60px 15px 15px 15px;\r\n    }\r\n    \r\n    .chat-header h2 {\r\n      font-size: 16px;\r\n    }\r\n    \r\n    .chat-messages {\r\n      padding: 15px;\r\n    }\r\n    \r\n    .message-content {\r\n      font-size: 14px;\r\n      padding: 10px 15px;\r\n    }\r\n    \r\n    .user-icon {\r\n      width: 32px;\r\n      height: 32px;\r\n    }\r\n    \r\n    .source-button {\r\n      padding: 6px 16px;\r\n      font-size: 13px;\r\n    }\r\n    \r\n    .message-input {\r\n      padding: 10px 15px;\r\n      font-size: 14px;\r\n    }\r\n    \r\n    .send-button {\r\n      padding: 10px 20px;\r\n      font-size: 14px;\r\n    }\r\n  }\r\n\r\n  \r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
